import config from '@config'
import { Purpose } from '@utils/aureus'
import { executeQuery as executeEmbeddedVideosQuery } from '@utils/aureus/queries/embeddedVideos'
import { JSONWidgetType as TeaserStandardVerticalVideoJSONWidgetType } from '@widgets/TeaserStandardVerticalVideo'

const {
  publication: { publication },
} = config

const isVideoRecommendationsEnabled = (): boolean => {
  const isRomandie = publication === 'romandie'

  return !isRomandie
}

export type VideoRecommendationItem =
  TeaserStandardVerticalVideoJSONWidgetType & {
    articleId: string
    aureusOfferId: string
  }

const getVideoRecommendations = async (id: string, purpose?: Purpose) => {
  const queryResult =
    (await executeEmbeddedVideosQuery({ contentBlacklist: id, purpose })) ?? []

  return queryResult.reduce((acc, curr) => {
    acc.push({
      ...curr.teasers.standardVerticalVideo,
      articleId: curr.articleID,
      aureusOfferId: curr.aureusOfferId,
    } satisfies VideoRecommendationItem)

    return acc
  }, [] as VideoRecommendationItem[])
}
export { isVideoRecommendationsEnabled, getVideoRecommendations }
